import { InternalAxiosRequestConfig } from 'axios';
import i18n from 'i18next';

export async function languageInterceptor(config: InternalAxiosRequestConfig) {
  const language = i18n.language;
  config.headers['Accept-Language'] = language;
  return config;
}
